import React, { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Search, Plus, Layers, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Dialog, DialogTrigger, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";

const Projects: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [form, setForm] = useState({
    nome: "",
    tipo: "",
    regiao: "",
    descricao: "",
    objetivos: "",
    resultados: "",
    responsavel: "",
    email: "",
    telefone: "",
    idComunidade: ""
  });
  const tiposProjeto = ["Mitigação", "Conservação", "Energia Renovável", "Reciclagem", "Outro"];
  const regioes = ["Norte", "Nordeste", "Centro-Oeste", "Sudeste", "Sul"];
  const [filtroTipo, setFiltroTipo] = useState("");
  const [filtroRegiao, setFiltroRegiao] = useState("");
  const [filtroStatus, setFiltroStatus] = useState("");
  const statusList = ["Ativo", "Em andamento", "Planejamento"];

  const projects = [
    {
      id: "PRJ-001",
      name: "Moeda Social Carbono",
      status: "Ativo",
      location: "Nacional",
      type: "Mitigação",
      date: "01/12/2024",
      progress: 75,
    }
  ];

  const filteredProjects = projects.filter(
    project =>
      (project.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project.type.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project.location.toLowerCase().includes(searchTerm.toLowerCase())) &&
      (filtroTipo === "" || project.type === filtroTipo) &&
      (filtroRegiao === "" || project.location.toLowerCase().includes(filtroRegiao.toLowerCase())) &&
      (filtroStatus === "" || project.status === filtroStatus)
  );

  const getStatusColor = (status: string) => {
    switch (status) {
      case "Ativo":
        return "bg-green-100 text-green-800";
      case "Em andamento":
        return "bg-blue-100 text-blue-800";
      case "Planejamento":
        return "bg-yellow-100 text-yellow-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  return (
    <div className="container mx-auto p-4 space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-800">Projetos</h1>
        <Dialog open={modalOpen} onOpenChange={setModalOpen}>
          <DialogTrigger asChild>
            <Button onClick={() => setModalOpen(true)}>
              <Plus className="mr-2 h-4 w-4" />
              Novo Projeto
            </Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Informações do Projeto</DialogTitle>
            </DialogHeader>
            <form className="space-y-6" onSubmit={e => { e.preventDefault(); setModalOpen(false); }}>
              <div>
                <label className="block text-sm font-medium mb-1">Nome do Projeto *</label>
                <Input value={form.nome} onChange={e => setForm(f => ({...f, nome: e.target.value}))} required />
              </div>
              <div className="flex gap-4">
                <div className="flex-1">
                  <label className="block text-sm font-medium mb-1">Tipo de Projeto *</label>
                  <select className="w-full border rounded px-3 py-2" value={form.tipo} onChange={e => setForm(f => ({...f, tipo: e.target.value}))} required>
                    <option value="">Selecione o tipo</option>
                    {tiposProjeto.map(tipo => <option key={tipo} value={tipo}>{tipo}</option>)}
                  </select>
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium mb-1">Região *</label>
                  <select className="w-full border rounded px-3 py-2" value={form.regiao} onChange={e => setForm(f => ({...f, regiao: e.target.value}))} required>
                    <option value="">Selecione a região</option>
                    {regioes.map(regiao => <option key={regiao} value={regiao}>{regiao}</option>)}
                  </select>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Descrição do Projeto *</label>
                <Textarea rows={3} value={form.descricao} onChange={e => setForm(f => ({...f, descricao: e.target.value}))} required placeholder="Descreva o projeto em detalhes" />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Objetivos *</label>
                <Textarea rows={2} value={form.objetivos} onChange={e => setForm(f => ({...f, objetivos: e.target.value}))} required placeholder="Descreva os principais objetivos do projeto" />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Resultados Esperados *</label>
                <Textarea rows={2} value={form.resultados} onChange={e => setForm(f => ({...f, resultados: e.target.value}))} required placeholder="Quais resultados você espera alcançar com este projeto?" />
              </div>
              <hr className="my-4" />
              <DialogTitle className="text-lg">Informações de Contato</DialogTitle>
              <div>
                <label className="block text-sm font-medium mb-1">Nome do Responsável *</label>
                <Input value={form.responsavel} onChange={e => setForm(f => ({...f, responsavel: e.target.value}))} required placeholder="Nome completo do responsável pelo projeto" />
              </div>
              <div className="flex gap-4">
                <div className="flex-1">
                  <label className="block text-sm font-medium mb-1">E-mail *</label>
                  <Input type="email" value={form.email} onChange={e => setForm(f => ({...f, email: e.target.value}))} required placeholder="seu@email.com" />
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium mb-1">Telefone *</label>
                  <Input type="tel" value={form.telefone} onChange={e => setForm(f => ({...f, telefone: e.target.value}))} required placeholder="(00) 00000-0000" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">INSERIR ID DO PROJETO COMUNIDADE/ MOEDA SOCIAL CARBONO</label>
                <Input value={form.idComunidade} onChange={e => setForm(f => ({...f, idComunidade: e.target.value}))} />
              </div>
              <DialogFooter className="gap-2">
                <Button type="button" variant="outline" onClick={() => setModalOpen(false)}>Cancelar</Button>
                <Button type="submit" className="bg-[#0073B6] text-white">Registrar Projeto</Button>
              </DialogFooter>
            </form>
          </DialogContent>
        </Dialog>
      </div>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle>Gestão de Projetos</CardTitle>
          <CardDescription>
            Acompanhe e gerencie todos os seus projetos de crédito de carbono
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col md:flex-row gap-4 md:items-center justify-between mb-6">
            <div className="w-full md:w-1/3 relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
              <Input 
                className="pl-10"
                placeholder="Buscar projetos..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="flex gap-2">
              <select className="border rounded px-2 py-1" value={filtroTipo} onChange={e => setFiltroTipo(e.target.value)}>
                <option value="">Tipo</option>
                {tiposProjeto.map(tipo => <option key={tipo} value={tipo}>{tipo}</option>)}
              </select>
              <select className="border rounded px-2 py-1" value={filtroRegiao} onChange={e => setFiltroRegiao(e.target.value)}>
                <option value="">Região</option>
                {regioes.map(regiao => <option key={regiao} value={regiao}>{regiao}</option>)}
              </select>
              <select className="border rounded px-2 py-1" value={filtroStatus} onChange={e => setFiltroStatus(e.target.value)}>
                <option value="">Status</option>
                {statusList.map(status => <option key={status} value={status}>{status}</option>)}
              </select>
              <Button variant="outline" size="sm" onClick={() => { setFiltroTipo(""); setFiltroRegiao(""); setFiltroStatus(""); }}>Limpar Filtros</Button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {filteredProjects.map((project) => (
              <Card key={project.id} className="border hover:shadow-md transition-shadow">
                <CardHeader className="pb-2">
                  <div className="flex justify-between items-start">
                    <div>
                      <CardTitle className="text-lg">{project.name}</CardTitle>
                      <CardDescription>{project.location}</CardDescription>
                    </div>
                    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${getStatusColor(project.status)}`}>
                      {project.status}
                    </span>
                  </div>
                </CardHeader>
                <CardContent>
                  <div className="space-y-4">
                    <div className="flex justify-between text-sm">
                      <span className="text-muted-foreground">ID:</span>
                      <span className="font-medium">{project.id}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <span className="text-muted-foreground">Tipo:</span>
                      <span className="font-medium">{project.type}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <span className="text-muted-foreground">Data de início:</span>
                      <span className="font-medium">{project.date}</span>
                    </div>
                    <div className="space-y-1">
                      <div className="flex justify-between text-sm">
                        <span className="text-muted-foreground">Progresso:</span>
                        <span className="font-medium">{project.progress}%</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div 
                          className="bg-green-500 h-2 rounded-full" 
                          style={{ width: `${project.progress}%` }}
                        ></div>
                      </div>
                    </div>
                    <div className="pt-2">
                      <Link to={`/admin/projects/${project.id}`}>
                        <Button variant="outline" className="w-full">
                          Ver detalhes
                          <ArrowRight className="ml-2 h-4 w-4" />
                        </Button>
                      </Link>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Projects;
